var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4897 2.72729C13.4897 3.68837 12.7185 4.45457 11.783 4.45457C10.8474 4.45457 10.0762 3.68837 10.0762 2.72729C10.0762 1.7662 10.8474 1 11.783 1C12.7185 1 13.4897 1.7662 13.4897 2.72729Z",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4897 12.2727C13.4897 13.2338 12.7185 14 11.783 14C10.8474 14 10.0762 13.2338 10.0762 12.2727C10.0762 11.3116 10.8474 10.5454 11.783 10.5454C12.7185 10.5454 13.4897 11.3116 13.4897 12.2727Z",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69286 8.18188C4.69286 9.14296 3.92161 9.90916 2.98608 9.90916C2.05055 9.90916 1.2793 9.14296 1.2793 8.18188C1.2793 7.22079 2.05055 6.45459 2.98608 6.45459C3.92161 6.45459 4.69286 7.22079 4.69286 8.18188Z",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75298 3.40906L5.01611 6.47725",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75298 11.9319L5.01611 8.86368",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.85ba7328a11f24fc289708bc0f5585f8.svg";
export { ForwardRef as ReactComponent };